module.exports = __webpack_public_path__ + "images/FUSA_icons/017-bitcoin.a06fc51030e4495403b0865420cf91d8.svg";